/**
 * A relative popover on desktop or a standard portal modal on mobile
 */

import React from 'react';
import { useIsMobile } from '../../../hooks';
import PortalOverlay, { PortalOverlayModal } from '../PortalOverlay';
import { Popover, PopoverProps } from './Popover';

/**
 * A responsive popover component that acts as a normal PortalOverlay on mobile
 * Or as an absolutely position menu on desktop
 *
 * This component handles closing the popover when a user clicks outside of the menu
 */
export const DesktopPopover: React.FCWithChildren<PopoverProps> = props => {
  const {
    onClose,
    name,
    top,
    left,
    right,
    bottom,
    zIndex,
    children,
    ...restProps
  } = props;
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <PortalOverlay
        name={name}
        onBackdropClick={onClose}
      >
        <PortalOverlayModal {...restProps}>
          {children}
        </PortalOverlayModal>
      </PortalOverlay>
    );
  }

  return (
    <Popover {...props} />
  );
};
